import { render, staticRenderFns } from "./RoomInfoCardSkeleton.vue?vue&type=template&id=7f1c611c&scoped=true"
import script from "./RoomInfoCardSkeleton.vue?vue&type=script&lang=js"
export * from "./RoomInfoCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./RoomInfoCardSkeleton.vue?vue&type=style&index=0&id=7f1c611c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1c611c",
  null
  
)

export default component.exports